import { FC } from "react";
import styles from "./Generic.module.css";

type Props = {
  type?: "white" | "blue";
};

export const Logo: FC<Props> = ({ type }) => {
  return (
    <img
      src={
        type === "white"
          ? "https://s3.us-east-1.amazonaws.com/d-ice.fr/assets/dice-logo-white.png"
          : "https://s3.us-east-1.amazonaws.com/d-ice.fr/assets/dice_logo.png"
      }
      className={styles.logo}
      alt="D-ICE Logo"
    />
  );
};
